import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import LocalLinksSection from "@/components/LocalLinksSection";
import GallerySection from "@/components/GallerySection";
import ReviewsSection from "@/components/ReviewsSection";
import AppointmentSection from "@/components/AppointmentSection";
import EstimateSection from "@/components/EstimateSection";
import Footer from "@/components/Footer";
import FloatingChatButton from "@/components/FloatingChatButton";
import WhatsAppWidget from "@/components/WhatsAppWidget";
import Navigation from "@/components/Navigation";
import SeoHead from "@/components/seo/SeoHead";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HOME_TITLE = "Pellon Morel Solutions | Plumbing, Drain & Repairs in Hampton Roads VA";
const HOME_DESC = "Pellon Morel Solutions provides professional plumbing, drain cleaning, and repair services in Virginia Beach, Chesapeake, Norfolk, and throughout Hampton Roads. Reliable service, fast response, and quality workmanship. Call (757) 650-3192.";

const HomePage = () => {
  const [services, setServices] = useState([]);
  const [gallery, setGallery] = useState([]);
  const { hash } = useLocation();

  useEffect(() => {
    fetchServices();
    fetchGallery();
  }, []);

  useEffect(() => {
    if (!hash) return;
    const el = document.getElementById(hash.slice(1));
    if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 150);
  }, [hash]);

  const fetchServices = async () => {
    try {
      const response = await axios.get(`${API}/services`);
      setServices(response.data);
    } catch (error) {
      console.error("Error fetching services:", error);
    }
  };

  const fetchGallery = async () => {
    try {
      const response = await axios.get(`${API}/gallery`);
      setGallery(response.data);
    } catch (error) {
      console.error("Error fetching gallery:", error);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <SeoHead title={HOME_TITLE} description={HOME_DESC} path="/" />
      <Navigation />
      <HeroSection />
      <ServicesSection />
      <LocalLinksSection />
      <GallerySection gallery={gallery} />
      <ReviewsSection />
      <AppointmentSection services={services} />
      <EstimateSection services={services} />
      <Footer />
      <FloatingChatButton />
      <WhatsAppWidget />
    </div>
  );
};

export default HomePage;